import React from "react";
import LandingLayout from "../../components/LandingLayout";

const Signup = () => {
  return <LandingLayout>Signup</LandingLayout>;
};

export default Signup;
